/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DelegationStatus } from '../../models/delegation-status';
import { GetUserDelegationRequestResponse } from '../../models/get-user-delegation-request-response';

export interface GetAllDelegateRequests$Params {

/**
 * the page number.
 */
  page?: number;

/**
 * the size of a page
 */
  size?: number;

/**
 * sort
 */
  sort?: string;

/**
 * search by user name fields
 */
  search?: string;

/**
 * Filter by delegation status
 */
  status?: Array<DelegationStatus>;

/**
 * Filters deligation requests that have their start date after or same as the provided date.
 * Expects date-time in <YYYY-MM-DDTHH:mm:ss.SSSZ> format
 */
  from?: string;

/**
 * Filters deligation requests that have their start date before or same as the provided date.
 * Expects date-time in <YYYY-MM-DDTHH:mm:ss.SSSZ> format
 */
  to?: string;
}

export function getAllDelegateRequests(http: HttpClient, rootUrl: string, params?: GetAllDelegateRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserDelegationRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllDelegateRequests.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
    rb.query('status', params.status, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserDelegationRequestResponse>;
    })
  );
}

getAllDelegateRequests.PATH = '/api/administration/delegations';
